import WebServiceRequest from '../Api/WebServiceRequest'

class BundleAddProductBundleRequest extends WebServiceRequest {
    constructor (context) {
        super(context)
        super.setTag('Bundle/AddProductToBundle')
    }
    setParams(data){
        super.setRequestParamDataObj(data)
    }
}

class BundleRemoveProductFromBundleRequest extends WebServiceRequest {
    constructor (context) {
        super(context)
        super.setTag('Bundle/RemoveProductFromBundle')
    }
    setParams(data){
        super.setRequestParamDataObj(data)
    }
}

class BundleGetBundleItemsRequest extends WebServiceRequest {
    constructor (context) {
        super(context)
        super.setTag('Bundle/GetBundleItems')
    }
    setParams(data){
        super.setRequestParam(data)
    }
}

export {
    BundleAddProductBundleRequest,
    BundleRemoveProductFromBundleRequest,
    BundleGetBundleItemsRequest
}